import {SettingParamTypes, FlowNodeData, FlowNodeTypes} from "@/types/node";
import {Node} from "@xyflow/react";

export const collectVariablesNodeBlueprint: Partial<Node<FlowNodeData>> = {
  type: FlowNodeTypes.COLLECT_VARIABLES,
  position: {x: 0, y: 0},
  measured: {height: 115, width: 340},
  data: {
    type: FlowNodeTypes.COLLECT_VARIABLES,
    settingsTitle: "Collect Variables",
    nodeTitle: "Collect Variables",
    description: "This is the collect variables node",
    onChange: () => {
      console.log("Start node changed");
    },
    isEmpty: true,
    settings: [
      {
        title: "Collect Variables",
        expandedSetting: true,
        description:
          "Collect variables from this step or earlier messages and use it later in the flow for branches and actions.",
        icon: "CaptureVariableIcon",
        params: [
          {
            label: "Instructions",
            placeholder:
              "Add instructions on how the AI Assistant should behave during this instruction.",
            type: SettingParamTypes.PROMPT,
            key: "instructions",
            tooltipMessage:
              "Describe how the agent should behave here. For example: ‘First ask the user for their age, then ask for their gender.’ This is useful if you need to collect multiple variables in sequence.",
            value: "",
          },
          {
            type: SettingParamTypes.CAPTURE,
            key: "variables",
            unitName: "Variable",
            value: [],
            settingName: "Variables",
          },
        ],
      },
    ],
  },
};
